/** Shown while the session is being decided (cached session or network). */
export function SplashScreen() {
  return (
    <div
      className="grid min-h-dvh place-items-center bg-background"
      role="status"
      aria-live="polite"
    >
      <div className="brand mb-0 animate-pulse">
        <div className="brand-mark">K</div>
        <div>
          KorOS<span className="text-primary">.</span>
        </div>
      </div>
    </div>
  );
}
